import { get, post } from "../../helpers/api_helper";
export const getReportStructureAction = reportID => {
  return get(`/reports/${reportID}`);
};
export const postReportDataAction = (reportID, data) => {
  return post(`/reports/${reportID}`, data);
};
